import api from '../../api/api';

export default {
  name: 'reset-password',
  data() {
    return {
      user: {
        password: '',
        password_confirm: '',
      },
      submitting: false,
      passwordSuccess: false,
      passwordFailed: false,
    };
  },
  methods: {
    changePassword() {
      if (this.user.password === this.user.password_confirm) {
        this.submitting = true;

        api
          .changePassword(this.user.password)
          .then(() => {
            this.passwordSuccess = true;
            setTimeout(
              () => this.$router.push({ name: 'Projects overview' }),
              5000,
            );
          })
          .catch((err) => err)
          .finally(() => (this.submitting = false));
      } else {
        this.passwordFailed = true;
      }
    },
  },
};
